<template>
  <AppLayout>
    <main>
      <div
        class="
          page-header
          pb-10
          page-header-dark
          bg-gradient-primary-to-secondary
        "
      >
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon"><i data-feather="filter"></i></div>
              <span>Rate</span>
            </h1>
            <div class="page-header-subtitle ml-2">Update Rate Details</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="card mb-4">
          <div class="card-header">Rate</div>
          <div class="card-body">
            <div v-if="pageLoading">
              <img
                style="width: 30%"
                class="d-block mx-auto"
                src="@/assets/loader.gif"
              />
            </div>
            <div v-else class="form">
              <form @submit.prevent="handleSubmit()">
                <div class="form-group">
                  <label for="">Broker</label
                  ><v-select
                    v-model="broker"
                    class="form-select"
                    label="name"
                    :options="paginated"
                    :filterable="false"
                    @search="onSearch"
                  >
                    <template #search="{ attributes, events }">
                      <span class="mt-1 mx-3 py-1" v-if="broker == null">
                        {{ party.party }}
                      </span>

                      <input
                        class="vs__search"
                        :required="
                          rate.party !== '' || party.party !== '' ? false : true
                        "
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </div>

                <div class="form-group">
                  <label for="">Type Of Cover</label
                  ><select
                    v-model="rate.typeofCovers"
                    class="form-control"
                    id="typeofCover"
                    required
                  >
                    <option value="">Select Type Of Cover</option>
                    <option
                      v-for="cover in coverTypes"
                      :key="cover.id"
                      :value="cover.name"
                    >
                      {{ cover.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="">Cover Scope</label
                  ><select
                    v-model="rate.cover"
                    class="form-control"
                    id="typeofCover"
                    required
                  >
                    <option value="">Select Cover Scope</option>
                    <option
                      v-for="cover in coverScopes"
                      :key="cover.id"
                      :value="cover.id"
                    >
                      {{ cover.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="">Voyage Type</label
                  ><select
                    v-model="rate.voyageType"
                    class="form-control"
                    id="typeofCover"
                    required
                  >
                    <option value="">Select Voyage Type</option>
                    <option
                      v-for="voyage in voyageTypes"
                      :key="voyage.id"
                      :value="voyage.name"
                    >
                      {{ voyage.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="name">Rate (%)</label
                  ><input
                    class="form-control"
                    id="name"
                    type="number"
                    step="0.001"
                    v-model="rate.name"
                    placeholder="Enter Rate "
                  />
                </div>

                <div class="form-group">
                  <label for="">Status</label
                  ><select
                    v-model="rate.status"
                    class="form-control"
                    id="typeofCover"
                    required
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                <button v-if="loading" class="btn btn-primary disabled">
                  <div
                    class="spinner-border spinner-border-sm mx-1 text-light"
                    rate="status"
                  ></div>
                  Loading...
                </button>
                <button v-else type="submit" class="btn btn-primary">
                  Update Rate
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </AppLayout>
</template>


<script>
import AppLayout from "@/layouts/AppLayout.vue";
import { mapState, mapActions } from "pinia";
import { useAdminStore } from "@/stores/admin";
import { useMarineStore } from "@/stores/marine";

export default {
  name: "Update Rate",
  components: { AppLayout },
  data() {
    return {
      broker: null,
      search: "",
      offset: 0,
      limit: 100,
      party: {
        party: "",
        partyId: "",
      },
    };
  },
  computed: {
    ...mapState(useAdminStore, [
      "loading",
      "pageLoading",
      "rate",
      "coverTypes",
      "users",
      "brokers",
      "voyageTypes",
    ]),
    ...mapState(useMarineStore, ["coverScopes"]),
    filtered() {
      return this.brokers.filter((broker) =>
        broker.name
          .toLocaleLowerCase()
          .includes(this.search.toLocaleLowerCase())
      );
    },
    paginated() {
      return this.filtered.slice(this.offset, this.limit + this.offset);
    },
  },

  methods: {
    ...mapActions(useAdminStore, [
      "updateRate",
      "getRate",
      "getAllCoverTypes",
      "getAllUsers",
      "getAllVoyageTypes",
    ]),
    ...mapActions(useMarineStore, ["getCoverScopes"]),
    async handleSubmit() {
      const res = await this.updateRate(this.rate, this.party);
      if (res == "success") {
        this.$router.push("/rates");
      }
    },

    onSearch(query) {
      this.search = query;
      this.offset = 0;
    },

    addBroker(broker) {
      if (this.broker !== null) {
        this.party.party = broker.name;
        this.party.partyId = broker.id.toString();
      }
    },
  },

  watch: {
    broker: function () {
      if (this.broker !== null) {
        this.addBroker(this.broker);
      }
    },
  },

  async created() {
    await this.getRate(this.$route.params.id);
    this.party.party = this.rate.party;
    this.party.partyId = this.rate.partyId;
    this.getAllCoverTypes();
    this.getAllUsers();
    this.getCoverScopes();
    this.getAllVoyageTypes();
  },
};
</script>